import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { Alert, Button, Form } from "react-bootstrap";

import api from "../../api";
import NotyfContext from "../../contexts/NotyfContext";

function ResetPassword() {
  const navigate = useNavigate();
  const notify = useContext(NotyfContext);

  return (
    <Formik
      initialValues={{
        email: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          setSubmitting(true);
          await api.post(
            `accounts/passwordreset?email=${encodeURIComponent(values.email)}`
          );
          navigate("/auth/sign-in");
          notify.open({
            type: "success",
            message: "Email has been sent!",
          });
          setStatus({ success: true });
          setErrors({});
          setSubmitting(false);

          // .catch((error) => {
          //   const message = error.message || "Something went wrong";

          //   setStatus({ success: false });
          //   setErrors({ submit: message });
          //   setSubmitting(false);
          // });
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert className="my-3" variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              className="no-background-input"
              type="email"
              name="email"
              label="Email Address"
              value={values.email}
              isInvalid={Boolean(touched.email && errors.email)}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {!!touched.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <div className="mt-3">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Send Password Reset
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ResetPassword;
